<template>
  <FormKit
    type="group"
    @input="v => handleInput(v)"
  >
    <div class="flex w-full justify-between space-x-2">
      <FormKit
        name="zipcode"
        :label="$t('sofie.address.zipcode')"
        type="text"
        outer-class="grow"
        validation="required"
      />
      <FormKit
        name="house_number"
        :label="$t('sofie.address.house_number')"
        type="text"
        outer-class="grow"
        validation="required"
      />
      <FormKit
        name="house_number_suffix"
        :label="$t('sofie.address.house_number_suffix')"
        type="text"
        outer-class="w-1/5"
      />
    </div>

    <div class="flex gap-2">
      <FormKit
        name="street"
        :label="$t('sofie.address.street')"
        type="text"
        outer-class="grow"
        validation="required"
      />
      <FormKit
        name="city"
        :label="$t('sofie.address.city')"
        type="text"
        outer-class="grow"
        validation="required"
      />
    </div>
    <FormKit
      name="country"
      :label="$t('sofie.address.country')"
      :options="COUNTRIES"
      type="select"
      outer-class="grow"
      validation="required"
    />
  </FormKit>
</template>

<script setup lang="ts">
import type {FormKitFrameworkContext} from '@formkit/core';
import {COUNTRIES} from '../../constants/countries';

const props = defineProps<{
  context: FormKitFrameworkContext
}>();

function handleInput(value: {
  zipcode: string
  house_number: string
  house_number_suffix: string
  street: string
  city: string
  country: string
} | undefined) {
  props.context.node.input(value);
}
</script>
